import React, {useEffect, useState} from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import styles from './UpdatePopUp.module.css';
import Button from "../../../components/common/button/Button";
import {getRegisterAPI} from "../../../services/term";
import {updateRegisterAPI} from "../../../services/admin";

interface UpdateRegisterPopUpProps {
    isOpen: boolean;
    onClose: () => void;
}

//회원가입 규정 수정 팝업
const UpdateRegisterPopUp: React.FC<UpdateRegisterPopUpProps> = ({isOpen, onClose}) => {
    const [register, setRegister] = useState<string>('');
    const [loading, setLoading] = useState(true);

    const handleSubmit = async () => {
        try {
            //회원가입 규정 수정 API
            await updateRegisterAPI({content: register});
        } catch (error) {
            console.error('Error update term request:', error);
        }
        fetchRegister();
        onClose();
    };

    const fetchRegister = async () => {
        try {
            setLoading(true);
            // 회원가입 규정 조회 API
            const response = await getRegisterAPI();
            setRegister(response);
        } catch (error) {
            console.error('Error fetching term request:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRegister();
    }, []);

    if (!isOpen) return null;

    if (loading) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2 className={styles.title}>개인정보 수집·이용 동의 작성</h2>
                    {/*회원가입 규정 수정 팝업 닫기 버튼*/}
                    <button onClick={onClose} className={styles.closeButton}>
                        <XMarkIcon className={styles.closeIcon}/>
                    </button>
                </div>
                <div className={styles.content}>
                    <div className={styles.formGroup}>
                        <label>개인정보 수집·이용 동의</label>
                        {/*회원가입 규정 입력창*/}
                        <textarea
                            value={register}
                            onChange={(e) => setRegister(e.target.value)}
                            placeholder="개인정보 수집·이용 동의 내용 작성"
                            className={styles.textarea}
                        />
                    </div>
                </div>

                <div className={styles.footer}>
                    {/*저장 버튼*/}
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={!register?.trim()}
                        className={styles.submitButton}
                    >
                        저장
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default UpdateRegisterPopUp;